"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerTemplates = void 0;
exports.customerTemplates = {
// "...": require("./templates/..."),
};
